import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

import { CREATE_TIERS, resolveGeneratorCtaHref } from '../generatorCta'

// Shared by the AI subscription landing and the per-object AI generator landings, which
// supply their own heading copy. The button label stays tier-driven rather than
// content-driven: a subscriber must not be told to "start generating for free" when the
// link takes them straight into the studio.
function CTABanner({ title, subtitle = '', subscriptionPaymentFormUrl = '' }) {
  // threeDStudioAccessTier and threeDStudioSubscriptionPaymentFormUrl are part of the
  // per-user payload flushed after /load-services.js (set in
  // has_fast_application_state_helpers.rb only when a user is signed in), so read them
  // from the full page config. Before that payload hydrates -- and for signed-out
  // visitors, who never get it -- the href falls back to the subscriptionPaymentFormUrl
  // SSR prop, which is the absolute (subdomain-qualified) URL in production so the CTA
  // does not 404 against the subscriptions-only payment-form route.
  const pageConfig = usePageConfig({ listener: 'full-page-config-loaded', checkIfAvailable: false })
  const tier = pageConfig?.threeDStudioAccessTier
  const paymentFormUrl = pageConfig?.threeDStudioSubscriptionPaymentFormUrl || subscriptionPaymentFormUrl

  let buttonLabel = 'Start Your Subscription'

  if (CREATE_TIERS.includes(tier)) {
    buttonLabel = 'Start Creating with AI'
  } else if (tier === 'eligible_for_trial') {
    buttonLabel = 'Try AI for Free'
  }

  return (
    <section className="ai-landing-cta-banner">
      <div className="ai-landing-cta-banner__card">
        <div className="ai-landing-cta-banner__content">
          <div className="ai-landing-cta-banner__text">
            <h2 className="ai-landing-cta-banner__title cgt-heading-500">{title}</h2>
            {subtitle && <p className="ai-landing-cta-banner__subtitle cgt-body-lg">{subtitle}</p>}
          </div>
          <Button type="primary" href={resolveGeneratorCtaHref({ tier, paymentFormUrl })}>
            {buttonLabel}
          </Button>
        </div>
        <img
          className="ai-landing-cta-banner__bird"
          src="/assets/ai_landing/cta_banner/bird.webp"
          width={840}
          height={807}
          loading="lazy"
          alt=""
          aria-hidden="true"
        />
      </div>
    </section>
  )
}

CTABanner.propTypes = {
  title: string.isRequired,
  subtitle: string,
  subscriptionPaymentFormUrl: string,
}

export default CTABanner
